import React from "react";
import ProgressBar from "../components/ProgressBar";
import TopBar from "../components/TopBar";
import Footerr from "../components/Footerr/Footerr";
import { Globe, Target, Users, Award, TrendingUp, Shield } from "lucide-react";
import { Link } from "react-router-dom";

function AboutUs() {
  return (
    <div className="bg-[#f8f9fb] min-h-screen flex flex-col">
      <ProgressBar />
      <TopBar />

      {/* Hero Section */}
      <section className="bg-gold-gradient mt-4 text-[#101c4c] py-20 px-4 text-center">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-extrabold mb-6 text-[#101c4c]">
            About <span className="gold-main">Brand.Gold</span>
          </h1>
          <p className="text-xl md:text-2xl text-[#101c4c]/90 max-w-3xl mx-auto font-medium leading-relaxed">
            We are redefining the digital frontier - empowering visionary brands
            to own, invest, and grow with the world's most exclusive digital
            assets.
          </p>
        </div>
      </section>

      {/* Company Overview */}
      <section className="max-w-6xl mx-auto px-6 py-16">
        <div className="bg-white rounded-3xl shadow-2xl border border-[#b99653]/20 p-12">
          <div className="flex items-center mb-8">
            <div className="w-14 h-14 rounded-2xl bg-gold-gradient flex items-center justify-center mr-4 shadow-lg">
              <Globe className="w-7 h-7 text-[#101c4c]" />
            </div>
            <h2 className="text-4xl font-bold text-[#101c4c]">Who We Are</h2>
          </div>
          <p className="text-gray-700 text-xl leading-relaxed mb-6">
            <strong>Brand.Gold</strong> is an exclusive domain marketplace by{" "}
            <strong>Terces Solutions Private Limited</strong>, built to empower
            creators, entrepreneurs, and enterprises in acquiring and managing
            premium digital identities. We connect high-value domain owners with
            buyers seeking authenticity, exclusivity, and prestige.
          </p>
          <p className="text-gray-700 text-xl leading-relaxed">
            Our mission is to make premium domains accessible through a
            transparent, intelligent marketplace where trust, efficiency, and
            innovation define every transaction.
          </p>
        </div>
      </section>

      {/* What We Do */}
      <section className="max-w-7xl mx-auto px-6 py-10">
        <h2 className="text-4xl font-bold text-center text-[#101c4c] mb-16">
          What We Do
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
          {/* Premium Marketplace */}
          <div className="bg-white border-2 border-[#b99653]/30 rounded-3xl shadow-xl p-10 flex flex-col hover:shadow-2xl hover:border-[#b99653] hover:-translate-y-2 transition-all duration-300">
            <div className="w-20 h-20 rounded-2xl bg-gold-gradient flex items-center justify-center mb-6 shadow-lg">
              <TrendingUp className="w-10 h-10 text-[#101c4c]" />
            </div>
            <h3 className="text-2xl font-bold text-[#101c4c] mb-4">
              Premium Domain Marketplace
            </h3>
            <p className="text-gray-600 text-lg leading-relaxed flex-1">
              Discover and acquire the most desirable digital properties in a
              transparent and intelligent ecosystem built for professionals.
            </p>
          </div>

          {/* Domain Trading */}
          <div className="bg-white border-2 border-[#b99653]/30 rounded-3xl shadow-xl p-10 flex flex-col hover:shadow-2xl hover:border-[#b99653] hover:-translate-y-2 transition-all duration-300">
            <div className="w-20 h-20 rounded-2xl bg-gold-gradient flex items-center justify-center mb-6 shadow-lg">
              <Globe className="w-10 h-10 text-[#101c4c]" />
            </div>
            <h3 className="text-2xl font-bold text-[#101c4c] mb-4">
              Domain Acquisition & Trading
            </h3>
            <p className="text-gray-600 text-lg leading-relaxed flex-1">
              We simplify premium domain acquisition and ownership through
              secure digital transfer systems and verified seller networks.
            </p>
          </div>

          {/* Consultation */}
          <div className="bg-white border-2 border-[#b99653]/30 rounded-3xl shadow-xl p-10 flex flex-col hover:shadow-2xl hover:border-[#b99653] hover:-translate-y-2 transition-all duration-300">
            <div className="w-20 h-20 rounded-2xl bg-gold-gradient flex items-center justify-center mb-6 shadow-lg">
              <Users className="w-10 h-10 text-[#101c4c]" />
            </div>
            <h3 className="text-2xl font-bold text-[#101c4c] mb-4">
              Domain Strategy Consultation
            </h3>
            <p className="text-gray-600 text-lg leading-relaxed flex-1">
              Get expert advice on valuation, brand-fit, and negotiation for
              domain purchases, ensuring maximum ROI on every investment.
            </p>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="max-w-6xl mx-auto px-6 py-16">
        <div className="bg-white border-2 border-[#b99653]/30 rounded-3xl shadow-2xl p-12">
          <div className="flex items-center mb-10">
            <div className="w-14 h-14 rounded-2xl bg-gold-gradient flex items-center justify-center mr-4 shadow-lg">
              <Award className="w-7 h-7 text-[#101c4c]" />
            </div>
            <h2 className="text-4xl font-bold text-[#101c4c]">
              Why Choose Brand.Gold?
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-8">
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-gold-gradient flex items-center justify-center flex-shrink-0 shadow-md">
                  <Shield className="w-6 h-6 text-[#101c4c]" />
                </div>
                <div>
                  <h4 className="font-bold text-xl text-[#101c4c] mb-2">
                    Secure Transactions
                  </h4>
                  <p className="text-gray-600 text-lg">
                    Multi-layer security for payments and transfers, backed by
                    escrow integrations.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-gold-gradient flex items-center justify-center flex-shrink-0 shadow-md">
                  <Target className="w-6 h-6 text-[#101c4c]" />
                </div>
                <div>
                  <h4 className="font-bold text-xl text-[#101c4c] mb-2">
                    Smart Matching Algorithms
                  </h4>
                  <p className="text-gray-600 text-lg">
                    Intelligent systems that connect the right domain to the
                    right buyer with precision.
                  </p>
                </div>
              </div>
            </div>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-gold-gradient flex items-center justify-center flex-shrink-0 shadow-md">
                  <TrendingUp className="w-6 h-6 text-[#101c4c]" />
                </div>
                <div>
                  <h4 className="font-bold text-xl text-[#101c4c] mb-2">
                    Market Expertise
                  </h4>
                  <p className="text-gray-600 text-lg">
                    Years of experience analyzing and optimizing digital asset
                    performance.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-gold-gradient flex items-center justify-center flex-shrink-0 shadow-md">
                  <Users className="w-6 h-6 text-[#101c4c]" />
                </div>
                <div>
                  <h4 className="font-bold text-xl text-[#101c4c] mb-2">
                    24/7 Support
                  </h4>
                  <p className="text-gray-600 text-lg">
                    Our support team ensures smooth onboarding and transactions
                    at every step.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision */}
      <section className="max-w-5xl mx-auto px-6 py-10 text-center">
        <h2 className="text-4xl font-bold text-[#101c4c] mb-10">Our Vision</h2>
        <div className="bg-white border-2 border-[#b99653]/30 rounded-3xl shadow-2xl p-12">
          <p className="text-xl text-gray-700 leading-relaxed mb-8">
            We envision a future where digital ownership defines credibility.
            Every brand - big or small - deserves access to premium domains that
            strengthen identity, trust, and growth.
          </p>
          <div className="bg-gold-gradient/50 border-l-4 border-[#b99653] p-8 rounded-r-2xl">
            <p className="text-[#101c4c] font-bold text-2xl italic">
              "Own. Invest. Grow. - Building digital legacies, one domain at a
              time."
            </p>
          </div>
        </div>
      </section>

      {/* Call To Action */}
      <section className="bg-gold-gradient text-black text-center py-20 px-6 rounded-t-[3rem] mt-16">
        <h2 className="text-4xl font-bold mb-6">
          Ready to Claim Your Digital Gold?
        </h2>
        <p className="text-xl opacity-90 mb-10 max-w-2xl mx-auto">
          Join thousands of entrepreneurs and investors shaping the next digital
          revolution with .gold domains.
        </p>
        <div className="flex flex-col sm:flex-row gap-6 justify-center">
          <Link to="/Marketplace">
            <button className="white-btn !border-[#b99653] !px-8 !py-4 !text-lg !font-bold">
              Explore Marketplace
            </button>
          </Link>
          <Link to="/marketplace-help">
            <button className="white-btn hover:!text-[black] !px-8 !py-4 !text-lg !font-bold">
              Get in Touch
            </button>
          </Link>
        </div>
      </section>

      <Footerr />
    </div>
  );
}

export default AboutUs;
